<app-bread-crumbs [(breadcrumbs)]="breadcrumbs"></app-bread-crumbs>
<div class="container">
  <div class="row">
    <div class="col-md-12 px-3">
      <h1><app-header-icon iconName="fiber_new"></app-header-icon>{{'NEWS' | translate}}</h1>
      <app-news-overview></app-news-overview>
    </div>
  </div>
</div>
